export default __webpack_public_path__ + "static/media/wSkirt_1.a1db9a5e.bin";